import config from './config';
import navigation from './navigation';
import keyValue from './keyValue';
import setReady from './setReady';
import iwa from './iwa';
import app from './app';
import launch from './launch';
var injectDefaultMiddleware = function (communicator) {
    if (!communicator.addOnSendMiddleware) {
        return;
    }
    communicator.addOnSendMiddleware(navigation);
    communicator.addOnSendMiddleware(keyValue);
    communicator.addOnSendMiddleware(setReady);
    communicator.addOnSendMiddleware(app);
    communicator.addOnSendMiddleware(iwa);
    communicator.addOnSendMiddleware(launch);
    return communicator;
};
export default {
    injectDefaultMiddleware: injectDefaultMiddleware,
    config: config,
    navigation: navigation,
    keyValue: keyValue,
    setReady: setReady,
    app: app,
    iwa: iwa,
};
//# sourceMappingURL=index.js.map